import { H6, SxProp, View } from 'dripsy';
import React, { useCallback, useContext, useEffect, useState } from 'react';

import { LayoutContext } from 'contexts/LayoutContext';
import { ModalContainerView } from '@/features/earn/screens/subscription/ModalContainerView';
import { DevToolsStackRoutes, DevToolsStackScreenProps } from '../types';
import { ModalHeader } from '@/design-system/components/modal';
import { UniButton } from '@/design-system/components/buttons';
import { UniTabHeader } from '@/design-system/components/tabs';
import { TextBody } from '@/design-system/components/typography';

export const DevToolsModal: React.FC<DevToolsStackScreenProps<DevToolsStackRoutes.Modal>> = ({ navigation }) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <View
          sx={{
            height: layout.isMobile ? '100%' : 'auto',
            width: layout.dimensions.width,
            maxWidth: layout.isMobile ? layout.dimensions.width : Math.min(500, layout.dimensions.width),
            backgroundColor: '$backgroundPrimary'
          }}
          onLayout={(event) => {
            const { width, height } = event.nativeEvent.layout;
            setDimensions({ width, height });
            onLayout(event);
          }}>
          <Header title="Dev Tools Modal" isMobile={layout.isMobile} onClose={() => navigation.popToTop()} />
          <View sx={{ padding: layout.isMobile ? '$5' : '$7', gap: '$7' }}>
            <TextBody semiBold>This is modal</TextBody>
            <UniButton label="Close" onPress={() => navigation.goBack()} size="default" />
          </View>
        </View>
      </View>
    </ModalContainerView>
  );
};

const Header = ({ title, isMobile, onClose }: { title: string; isMobile: boolean; onClose: () => void }) => {
  if (isMobile) {
    return <UniTabHeader title={title} onBack={onClose} />;
  }

  return <ModalHeader title={title} closeModal={onClose} />;
};

enum StyleName {
  container = 'container',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {},
  pageItem: {}
};
